import { Injectable } from "@angular/core";
import { LacreController } from '../../controllers/mob/lacre.controller';
import { LacreDTO, LacreDTOList } from '../../model/dtos/mob/lacre.dto';
import { ApiService } from "../api-service.interface";
import { LoaderService } from "../loader.service";

@Injectable()
export class LacreService implements ApiService<LacreDTO>{

    constructor(
        private _lacreController: LacreController,
        private _loaderService: LoaderService
    ) { }

    find(search?: any): Promise<LacreDTO[]> {
        this._loaderService.show();
        return this._lacreController.find(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }

    getLacres(search?: any): Promise<LacreDTOList> {
        this._loaderService.show();
        return this._lacreController.getLacres(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }

    get(id: number): Promise<LacreDTO> {
        this._loaderService.show();
        return this._lacreController.get(id).finally(() => this._loaderService.hide());
    }

    save(entity: LacreDTO): Promise<LacreDTO> {
        if (!entity.cdLacre)
            return this.create(entity);
        return this.update(entity);
    }

    create(entity: LacreDTO): Promise<LacreDTO> {
        this._loaderService.show();
        return this._lacreController.create(entity).finally(() => this._loaderService.hide());
    }

    update(entity: LacreDTO): Promise<LacreDTO> {
        this._loaderService.show();
        return this._lacreController.update(entity).finally(() => this._loaderService.hide());
    }

    createLote(entities: Array<LacreDTO>): Promise<Array<LacreDTO>> {
        this._loaderService.show();
        return this._lacreController.createLote(entities).finally(() => this._loaderService.hide());
    }

    async delete(cdLacre: number) {
        this._loaderService.show();
        return this._lacreController.delete(cdLacre).finally(() => this._loaderService.hide());
    }

    async getLacreByPrefixo(nrPrefixo: number) {
        this._loaderService.show();
        return this._lacreController.getLacreByPrefixo(nrPrefixo).finally(() => this._loaderService.hide());
    }
}